import React from "react";
var __jsx = React.createElement;
import { FormControl, MenuItem, Select } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { Chevron } from 'theme/icons';
import { Container, SelectSlideContainer } from './SlidePosition.style';

var SlidePosition = function SlidePosition(_ref) {
  var displayedFieldIndex = _ref.displayedFieldIndex,
      repeatedFieldsCount = _ref.repeatedFieldsCount,
      moveSlide = _ref.moveSlide;
  var intl = useIntl();
  return __jsx(Container, null, intl.formatMessage({
    id: 'repeatable-fields.slide-position-label'
  }), __jsx(SelectSlideContainer, null, __jsx(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, __jsx(Select, {
    onChange: function onChange(event) {
      return moveSlide(displayedFieldIndex, event.target.value);
    },
    value: displayedFieldIndex,
    autoWidth: true,
    IconComponent: Chevron
  }, Array.from(Array(repeatedFieldsCount).keys()).map(function (slideIndex) {
    return __jsx(MenuItem, {
      key: slideIndex,
      value: slideIndex
    }, intl.formatMessage({
      id: 'repeatable-fields.slide-position'
    }, {
      position: slideIndex + 1,
      total: repeatedFieldsCount
    }));
  })))));
};

export default SlidePosition;